import React, { useState } from 'react'
import BabaForm from 'components/forms/Index'
import PropTypes from 'prop-types'

const OrderCheckoutValidationCouponForm = ({
  order,
  urls,
  onOrderModification,
  authenticityToken
}) => {
  const [showCouponForm, setShowCouponForm] = useState(false)
  const [couponName, setCouponName] = useState(order.couponName)
  const [errorMessage, setErrorMessage] = useState(order.couponErrorMessage)

  const handleCouponClick = () => {
    setShowCouponForm((prev) => !prev)
  }

  const handleCouponChange = (object, field, value) => {
    setCouponName(value)
  }

  const successCoupon = (data) => {
    onOrderModification(data)
    setErrorMessage(data.order.couponErrorMessage)
  }

  const errorCoupon = () => {
    setErrorMessage('Un problème est survenu, veuillez réessayer.')
  }

  const handleCouponValidate = async () => {
    if (!couponName) {
      return
    }

    try {
      const response = await fetch(urls.couponUpdateURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          coupon: { coupon_name: couponName },
          authenticity_token: authenticityToken
        }),
        cache: 'no-store'
      })

      if (!response.ok) {
        errorCoupon()
      }

      const data = await response.json()
      successCoupon(data)
    } catch (error) {
      errorCoupon()
    }
  }

  const showCouponArrow = showCouponForm ? (
    <span className="glyphicon glyphicon-menu-up" />
  ) : (
    <span className="glyphicon glyphicon-menu-down" />
  )

  let couponValidationMessage = null
  if (showCouponForm && order.couponId !== null) {
    couponValidationMessage = `Code promo appliqué : ${order.couponName}`
  }

  return (
    <div className="coupon-container mb-2">
      <div className="clickable mb-2" onClick={handleCouponClick}>
        Ajouter un code promo{showCouponArrow}
      </div>
      <div className={showCouponForm ? '' : 'hidden'}>
        <div className="row">
          <div className="col-xs-6">
            <BabaForm.FormLine>
              <BabaForm.BabaInput
                type="text"
                objectName="order"
                fieldName="coupon"
                defaultValue={order.couponName}
                placeHolder="Code promo"
                hideLabel={true}
                onChange={handleCouponChange}
                onEnterPress={handleCouponValidate}
              />
            </BabaForm.FormLine>
          </div>
          <div className="col-xs-6">
            <button
              onClick={handleCouponValidate}
              disabled={!couponName}
              className="btn btn-primary inline-btn">
              OK
            </button>
          </div>
        </div>

        <div className="row">
          {errorMessage && (
            <div className="col-xs-12 text-danger">{errorMessage}</div>
          )}
          {couponValidationMessage && (
            <div className="col-xs-12 text-success">
              {couponValidationMessage}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

OrderCheckoutValidationCouponForm.propTypes = {
  order: PropTypes.object.isRequired,
  urls: PropTypes.object.isRequired,
  onOrderModification: PropTypes.func,
  authenticityToken: PropTypes.string.isRequired
}

export default OrderCheckoutValidationCouponForm
